module OnlineDPR.Application.Client.UserSync

open Browser.XMLHttpRequest
open Elmish
open Fable.Core.JsInterop
open Fable.React
open Fable.React.Props
open Fetch

open OnlineDPR.Application.Shared

type Msg =
| FileSelected of obj
| FileUploaded of Result<UserSyncResult, string>

let init() =
    (UserSyncPageModel { File = [||]
                         Result = None
                         Pending = None
                         Success = false
                         ErrorMessage = None}), []

let postData (file) =
    promise {
        let formData = FormData.Create()
        formData.append("file.csv", file)
        let props = [ RequestProperties.Method HttpMethod.POST
                      RequestProperties.Headers ( unbox (EncType "multipart/form-data") )
                      RequestProperties.Body (formData |> unbox) ]
        return! Http.fetchAs<UserSyncResult> (APIUrls.UserSync) props
    }

let uploadFileCommand file =
    Cmd.OfPromise.either postData file (FileUploaded)  (Http.toErrorMessage >> FileUploaded)

let update msg (model:UserSyncModel) =
    match msg with
    | FileSelected file -> { model with Pending = Some true }, (uploadFileCommand file)
    | FileUploaded (Ok result)  -> { model with Result = Some result; Pending = Some false; Success = true }, []
    | FileUploaded (Error msg)  -> { model with Pending = Some false; Success = false; ErrorMessage = Some msg }, []
    | _ -> model, []

let showFeedback pending success errormessage =
    match pending, success, errormessage with
    | Some false, true, _ -> str "\nImport erfolgreich abgeschlossen"
    | Some false, false, None -> str "\nUnbekannter Fehler bei Import"
    | Some false, false, Some s -> str ("\nFehler bei Import: " + s)
    | Some true, _, _ -> Components.spinner
    | None, _, _ -> ofList []

let renderLogins (result:UserSyncResult) =
    if result.AddedUsers.Length > 0 then
        div [Class "card"] [
            div [Class "card-block"] [
                div [Class "card-title-block"] [ h3 [Class "title"] [ str "Neue Logins" ] ]
                section [] [ table [ Class "table" ] [ thead [] [ tr [] [ th [] [str "Login"]
                                                                          th [] [str "Passwort"]
                                                                          th [] [str "E-Mail" ]]]
                                                       tbody [] [ result.AddedUsers
                                                                |> List.map (fun a -> tr [ Key a.Login ] [ td [] [ pre [] [str a.Login]]
                                                                                                           td [] [ pre [] [str a.Password]]
                                                                                                           td [] [ pre [] [str (match a.EMail with
                                                                                                                                | None -> ""
                                                                                                                                | Some s -> s)]]] )
                                                                |> ofList]]]]]
    else
        [] |> ofList

let renderStringsToList title (lines:string list) =
    if lines.Length > 0 then
        div [Class "card"] [
            div [Class "card-block"] [
                div [Class "card-title-block"] [ h3 [Class "title"] [ str title ] ]
                section [] [ ul [ ] [ lines
                                      |> List.map (fun a -> li [] [ str a] )
                                      |> ofList]]]]
    else
        [] |> ofList

let renderResult (result:UserSyncResult) =
    [ renderLogins result
      renderStringsToList "Folgenden Clubs wird kein Land zugeordnet:" result.ClubsWithoutCounty
      renderStringsToList "Folgenden Clubs werden mehrere Länder zugeordnet:" result.ClubsWithMultipleCountries
      renderStringsToList "Folgende User haben keine Email-Adresse:" result.LoginsWithoutEMail
    ] |> ofList

let view (model:UserSyncModel) dispatch =
    [ div [] [ input [ Type "file"
                       OnChange (fun ev -> dispatch (FileSelected (ev.target?files?item(0))))]
               span [ Class "feedback" ]
                    [ showFeedback model.Pending model.Success model.ErrorMessage ] ]
      (match model.Result with
      | None -> [] |> ofList
      | Some result -> renderResult result)
      ]
    |> ofList
